require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./starling-1-1-17-1.json") })
        }
      }, "path---starling-1-1-17-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---starling-1-1-17-1!./.cache/json/starling-1-1-17-1.json
// module id = 575
// module chunks = 231608221292675